module.exports = __webpack_public_path__ + "img/dots-5.4404d657.svg";